// these 3 will not always be true. Rig it up in the future to have these
// heights be coming from refs and stored in Workspace provider
export const WKSPC_VIEW_CONTROL_HEIGHT = 49; // account for border

export const WKSPC_MOBILE_HORIZONTAL_PADDING = 12;
export const WKSPC_DESKTOP_HORIZONTAL_PADDING_WITH_SIDENAV_OPEN = 48;
export const WKSPC_DESKTOP_HORIZONTAL_PADDING_WITH_SIDENAV_CLOSED = 48;
export const SEARCH_INITIAL_HEADER_HEIGHT = 72;
export const WKSPC_CLIP_INFO_HEIGHT = 48;
export const WKSPC_CUSTOM_FIELD_DISPLAY_HEIGHT = 26;

export const WKSPC_GALLERY_BUTTON_FOCUS_BORDER_WIDTH = 4;
export const WKSPC_GALLERY_FIRST_SECTION_GAP_MOBILE = 40 + WKSPC_GALLERY_BUTTON_FOCUS_BORDER_WIDTH;
export const WKSPC_GALLERY_FIRST_SECTION_GAP_DESKTOP = 40 + WKSPC_GALLERY_BUTTON_FOCUS_BORDER_WIDTH;

export const SEARCH_STATIC_HEADER_Z_INDEX = 5;

export const UPLOAD_PANE_WIDTH_CLASSNAME = `w-[370px]`;

export const HEADER_MOBILE_HORIZONTAL_PADDING = 12;
export const HEADER_DESKTOP_HORIZONTAL_PADDING = 48;
